export default {
  Close: new Event('close-notification-banner'),

  Notify(options) {
    const event = new CustomEvent('notify', {
      detail: options,
    });

    return event;
  },
};
